import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {OAuthService} from "angular-oauth2-oidc";
import {environment} from "../../environments/environment.prod";
import {DfeDTOResponse} from "../../model/dto/dfe/DfeDTOResponse";
import {Xml} from "../../model/Xml";
import {ActivatedRoute} from "@angular/router";

@Injectable()
export class DfeProvider {
  apiDfe: string = "/fiscal/v1/dfe";

  constructor(
    public http: HttpClient,
    public oauthService: OAuthService,
    private activeRoute: ActivatedRoute
  ) {
  }

  getAllDfes() {
    return new Promise((resolve, reject) => {
      this.http
        .get<DfeDTOResponse[]>(
          `${environment.apiLogin}${this.apiDfe}/${localStorage.getItem("idEmpresa")}`,
          {headers: {Authorization: this.oauthService.authorizationHeader()}}
        )
        .subscribe(resolve, reject);
    });
  }

  getDfeByID(id: string) {
    return new Promise((resolve, reject) => {
      this.http
        .get<DfeDTOResponse>(
          `${environment.apiLogin}${this.apiDfe}/${localStorage.getItem("idEmpresa")}/${id}/viewer`,
          {headers: {Authorization: this.oauthService.authorizationHeader()}}
        )
        .subscribe(resolve, reject);
    });
  }

  getViewerByProductId(id: string) {
    return new Promise((resolve, reject) => {
      this.http
        .get<DfeDTOResponse>(
          `${environment.apiLogin}${this.apiDfe}/${localStorage.getItem("idEmpresa")}/viewer/${id}`,
          {headers: {Authorization: this.oauthService.authorizationHeader()}}
        )
        .subscribe(resolve, reject);
    });
  }

  getDfeByDay(day: string) {
    return new Promise((resolve, reject) => {
      this.http
        .get<DfeDTOResponse[]>(
          `${environment.apiLogin}${this.apiDfe}/${localStorage.getItem("idEmpresa")}/${day}`,
          {headers: {Authorization: this.oauthService.authorizationHeader()}}
        )
        .subscribe(resolve, reject);
    });
  }

  getDfeRecent() {
    return new Promise((resolve, reject) => {
      this.http
        .get<DfeDTOResponse[]>(
          `${environment.apiLogin}${this.apiDfe}/recent/${localStorage.getItem("idEmpresa")}/count`,
          {headers: {Authorization: this.oauthService.authorizationHeader()}}
        )
        .subscribe(resolve, reject);
    });
  }

  getDfeByPeriod(start: string, end: string) {
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${environment.apiLogin}${this.apiDfe}/period/${localStorage.getItem("idEmpresa")}/${start}/${end}`,
          {headers: {Authorization: this.oauthService.authorizationHeader()}}
        )
        .subscribe(resolve, reject);
    });
  }

  getDfeByPeriodPlannedPay(start: string, end: string) {
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${environment.apiLogin}/fiscal/v1/planned_payment/by-expiration-date-period/${localStorage.getItem("idEmpresa")}/${start}/${end}`,
          {headers: {Authorization: this.oauthService.authorizationHeader()}}
        )
        .subscribe(resolve, reject);
    });
  }

  getXmlDfeById(ids) {
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${environment.apiLogin}${this.apiDfe}/xml/by-ids`,
          ids,
          {headers: {Authorization: this.oauthService.authorizationHeader()}}
        )
        .subscribe(resolve, reject);
    });
  }

  getDfeNcmCfop(obj, start, end) {
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${environment.apiLogin}${this.apiDfe}/ncm-cfop/${localStorage.getItem("idEmpresa")}/${start}/${end}`,
          obj,
          {headers: {Authorization: this.oauthService.authorizationHeader()}}
        )
        .subscribe(resolve, reject);
    });
  }

  getDfeNcmCfopVencimento(obj, start, end) {
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${environment.apiLogin}/fiscal/v1/planned_payment/by-ncm-cfop/${localStorage.getItem("idEmpresa")}/${start}/${end}`,
          obj,
          {headers: {Authorization: this.oauthService.authorizationHeader()}}
        )
        .subscribe(resolve, reject);
    });
  }

  getDfeByPlannedPayment(id) {
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${environment.apiLogin}${this.apiDfe}/${localStorage.getItem("idEmpresa")}/by-planned-payment/${id}/viewer`,
          {headers: {Authorization: this.oauthService.authorizationHeader()}}
        )
        .subscribe(resolve, reject);
    });
  }

  getDfeIdByPlannedPaymentId(id) {
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${environment.apiLogin}/fiscal/v1/planned_payment/dfe-id/${localStorage.getItem("idEmpresa")}/${id}`,
          {headers: {Authorization: this.oauthService.authorizationHeader()}}
        )
        .subscribe(resolve, reject);
    });
  }

  postDfe(dfe: any) {
    return new Promise((resolve, reject) => {
      this.http
        .post<DfeDTOResponse>(
          `${environment.apiLogin}${this.apiDfe}`,
          dfe,
          {headers: {Authorization: this.oauthService.authorizationHeader()}}
        )
        .subscribe(resolve, reject);
    });
  }

  postDfes(dfes: Xml[]) {
    return new Promise((resolve, reject) => {
      this.http
        .post<DfeDTOResponse[]>(
          `${environment.apiLogin}${this.apiDfe}/all`,
          dfes,
          {headers: {Authorization: this.oauthService.authorizationHeader()}}
        )
        .subscribe(resolve, reject);
    });
  }

  putFolderDfes(dfes: { newFolderId: number; dfeIds: number[] }) {
    return new Promise((resolve, reject) => {
      this.http
        .put<DfeDTOResponse>(
          `${environment.apiLogin}${this.apiDfe}/${localStorage.getItem("idEmpresa")}/folder`,
          dfes,
          {headers: {Authorization: this.oauthService.authorizationHeader()}}
        )
        .subscribe(resolve, reject);
    });
  }

  getAllDfesProducts(id: any) {
    return new Promise((resolve, reject) => {
      this.http
        .get<any[]>(
          `${environment.apiLogin}${this.apiDfe}/${localStorage.getItem("idEmpresa")}/products-dfe/${id}`,
          {headers: {Authorization: this.oauthService.authorizationHeader()}}
        )
        .subscribe(resolve, reject);
    });
  }

  getDfeByPeriodInvalid(start, end){
    return new Promise((resolve, reject) => {
      this.http
        .get<any[]>(
          `${environment.apiLogin}${this.apiDfe}/period/invalids/${localStorage.getItem('idEmpresa')}/${start}/${end}`,
          {headers: {Authorization: this.oauthService.authorizationHeader()}}
        )
        .subscribe(resolve, reject);
    });
  }

  getDfeByPeriodPlannedPayInvalid(start, end){
    return new Promise((resolve, reject) => {
      this.http
        .get<any[]>(
          `${environment.apiLogin}/fiscal/v1/planned_payment/by-expiration-date-period/invalids/${localStorage.getItem('idEmpresa')}/${start}/${end}`,
          {headers: {Authorization: this.oauthService.authorizationHeader()}}
        )
        .subscribe(resolve, reject);
    });
  }

  getDfeNcmCfopInvalids(obj, start, end) {
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${environment.apiLogin}${this.apiDfe}/ncm-cfop/invalids/${localStorage.getItem("idEmpresa")}/${start}/${end}`,
          obj,
          {headers: {Authorization: this.oauthService.authorizationHeader()}}
        )
        .subscribe(resolve, reject);
    });
  }

  getDfeNcmCfopVencimentoInvalids(obj, start, end) {
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${environment.apiLogin}/fiscal/v1/planned_payment/by-ncm-cfop/invalids/${localStorage.getItem("idEmpresa")}/${start}/${end}`,
          obj,
          {headers: {Authorization: this.oauthService.authorizationHeader()}}
        )
        .subscribe(resolve, reject);
    });
  }
}
